module.exports = __webpack_public_path__ + "img/Austin-Mallia.dd63164c.png";